
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { ChangePasswordDialog } from '../dialogs/ChangePasswordDialog'

export function SecuritySection() {
  const [email, setEmail] = useState('hi@shadcndesign.com')
  const [password] = useState('••••••••')
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false)

  const handleEmailChange = () => {
    // TODO: Implement email change logic
  }

  const handlePasswordChange = () => {
    setPasswordDialogOpen(true)
  }

  return (
    <div className="p-6 flex flex-col gap-6">
      <div>
        <h3 className="text-base font-semibold">Security</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Manage your account security and authentication methods.
        </p>
      </div>

      <div className="space-y-6">
        {/* Email */}
        <div className="flex flex-col gap-2">
          <Label className="text-sm font-medium">Email</Label>
          <div className="flex items-center gap-2">
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1"
              readOnly
            />
            <Button variant="outline" size="lg" onClick={handleEmailChange}>
              Change
            </Button>
          </div>
        </div>

        {/* Password */}
        <div className="flex flex-col gap-2">
          <Label className="text-sm font-medium">Password</Label>
          <div className="flex items-center gap-2">
            <Input
              value={password}
              className="flex-1"
              readOnly
            />
            <Button variant="outline" size="lg" onClick={handlePasswordChange}>
              Change
            </Button>
          </div>
        </div>
      </div>

      {/* Dialogs */}
      {passwordDialogOpen && (
        <ChangePasswordDialog
          open={passwordDialogOpen}
          onOpenChange={setPasswordDialogOpen}
        />
      )}
    </div>
  )
}
